import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Button from 'kpc/components/button';
import Icon from 'kpc/components/icon';
import Tooltip from 'kpc/components/tooltip';
import Message from 'kpc/components/message';

@Component({
    components: {
        Button, Icon, Tooltip,
    }
})
export default class CopyIcon extends Vue {

    @Prop({
        required: true,
        default: ''
    })
    content!: string


    // success() {
    //     Message.success(this.$trans(`复制成功`), 3000);
    // }

    onSuccess() {
        Message.success('复制成功')
    }
    onError() {
        Message.error('复制失败')
    }

}
